"use client";

import { useTranslations } from "next-intl";
import { useEffect } from "react";

import { isProduction } from "@/env";
import { onServerTimeSyncError, synchronizeTime } from "@/utils/server-time";

import { toast } from "./toast";

let hasReportedSyncFailure = false;

/**
 * Component that synchronizes server time on mount to handle devices with
 * incorrect clocks. This prevents transaction expiration timestamp errors and
 * stale data windows (e.g. wrong campaign-week trades on Card Vault).
 *
 * Subscribes to sync failures via `onServerTimeSyncError` so the toast lives
 * here in the UI layer instead of inside the time util. Throttled to once per
 * page load so a flaky chain RPC doesn't spam the user.
 */
export function ServerTimeSync() {
  const t = useTranslations("serverTimeSync");

  useEffect(() => {
    const unsubscribe = onServerTimeSyncError(() => {
      if (!isProduction || hasReportedSyncFailure) return;
      hasReportedSyncFailure = true;
      toast({
        title: t("errorToast.title"),
        description: t("errorToast.description"),
        variant: "warning",
        id: "server-time-sync-failed",
      });
    });
    void synchronizeTime();
    return unsubscribe;
  }, [t]);

  return null;
}
